module.exports = __webpack_public_path__ + "static/img/words.6f6e153b.png";